import { render, staticRenderFns } from "./GroupRegistration.vue?vue&type=template&id=fbc85104"
import script from "./GroupRegistration.vue?vue&type=script&lang=js"
export * from "./GroupRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports